import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractActionService} from "../../../../core/service/v2/service/action/abstractAction.service";
import {DocumentModel} from "../model/document.model";
import {CustomizeHttpUrlGenerator} from "../../../../../store/core/url/customizeHttpUrlGenerator";
import {DocumentConverter} from "../converter/document.converter";
import {Payload} from "../../../../core/service/payload/payload";
import {Moment} from "moment";
import {PayloadWithId} from "../../../../core/service/payload/payloadWithId";
import {PhoneSavePayload} from "../../../../common/phone/payload/phoneSave.payload";

@Injectable()
export class DocumentSendSignUrlActionService
    extends AbstractActionService<DocumentSendSignUrlPayload, DocumentModel> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient,
                       private converter: DocumentConverter) {
        super('Document', 'send-sign-url', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: any): DocumentModel {
        return this.converter.convert(response);
    }
}

export class DocumentSendSignUrlPayload extends PayloadWithId{
    content: string;
    email: DocumentSendSignUrlEmailPayload;
    sms: DocumentSendSignUrlSmsPayload;
}

export class DocumentSendSignUrlSmsPayload implements Payload{
    to: PhoneSavePayload;

}

export class DocumentSendSignUrlEmailPayload implements Payload{
    to: string;
    subject: string;

}
